// eslint-disable-next-line max-len

import { createSelector, createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ServiceGroup } from '@quorum/models/xs-resource';

export interface DeclinedServicesState extends EntityState<ServiceGroup> {}

export const declinedServicesAdapter: EntityAdapter<ServiceGroup> = createEntityAdapter<ServiceGroup>({
  selectId: (serviceGroup: ServiceGroup) => serviceGroup.id
});

export const initialState: DeclinedServicesState = declinedServicesAdapter.getInitialState({});
export const DeclinedServicesFeatureSelector = createFeatureSelector<any>('vehicleMaintenance');
export const declinedServiceSelector = createSelector(
  DeclinedServicesFeatureSelector,
  (state: any) => state.declinedServices
);
export const { selectIds, selectEntities, selectAll, selectTotal } = declinedServicesAdapter.getSelectors(
  declinedServiceSelector
);
